import {IFeature_CONO} from "../types";

export function createPointSourceFeature (feature: IFeature_CONO): IFeature_CONO {
    return {
        ...feature,
        properties: {
            ...feature.properties,
            'icon-color': '#ee7400',
            title: feature.properties.Name as string,
            icon: 'circle',
        }
    };
}